import { NgModule } from '@angular/core';
import { HeaderComponent } from '@tools/components/header/header.component';
import { PageLayoutModule } from '../page-layout/page-layout.module';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
    declarations: [
        HeaderComponent
    ],
    imports: [
        TranslocoModule,
        PageLayoutModule
    ],
    exports: [
        HeaderComponent
    ]
})
export class HeaderModule
{
}
